import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const GetAllCampagins = async (pageNo, limit, where) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}?page=${pageNo}&limit=${limit}`,
    {
      params: {
        where: JSON.stringify(where)
      }
    }
  );
  return response;
};

export const GetCampaignById = async (campaignId) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/${campaignId}`,
    {}
  );
  return response;
};

export const CreateCampaign = async (payload) => {
  const response = await AudioCubeApiCallerInstance.post(
    SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS,
    payload
  );
  return response;
};

export const UpdateCampaign = async (campaignId, payload) => {
  const response = await AudioCubeApiCallerInstance.patch(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/${campaignId}`,
    payload
  );
  return response;
};

export const GetCampaignStats = async () => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/stats`
  );
  return response;
};

export const DisableCampaign = async (campaignId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/${campaignId}/disable`
  );
  return response;
};

export const EnableCampaign = async (campaignId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/${campaignId}/enable`
  );
  return response;
};
export const TriggerCampaign = async (campaignId) => {
  const response = await AudioCubeApiCallerInstance.post(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ALL_CAMPAIGNS}/${campaignId}/trigger-audio`
  );
  return response;
};

export const CampaignGraphData = async (startDate, endDate, interval) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.CAMPAIGN_GRAPH}?startDate=${startDate}&endDate=${endDate}&interval=${interval}`
  );
  return response;
};
